import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const getBatchFormValidation = (name: string) => {
  const message = `${name} is required`;
  return z.string({ required_error: message }).nonempty({ message });
};

export const BATCH_FORM_VALIDATION_SCHEMA = zodResolver(
  z.object({
    name: getBatchFormValidation("Batch Name"),
    description: getBatchFormValidation("Batch Description"),
    dueDate: getBatchFormValidation("Due Date"),
    mondayBoardLink: z.string().optional(),
  }),
);
